export const state = {
  permissions: []
}

export default state



// WEBPACK FOOTER //
// ./src/store/module/permission/state.js